import { useEffect,useState } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import Pagination from '../Common/Pagination';

const Aggregate = () => {

    const [nationalCode,setNationalCode] = useState();
    const [surveys,setSurveys] = useState([]);
    const [surveyId,setSurveyId] = useState();
    const [rows,setRows] = useState([]);
    const [fetchedData,setFetchedData] = useState(false);
    const [isLoading,setIsLoading] = useState(false);

    const [lastPage,setLastPage] = useState(0);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [count,setCount] = useState(0);

    const { readData: getOpinions } = useEntityCrud('Opinions/getAll');
    const { readData: getReports } = useEntityCrud('Report/LotteryStat');

    useEffect(() => {
        getOpinions().then(({ data }) => {
            let opinionsArr = [];
            if (data.status)
                data.result.map(item => {
                    opinionsArr.push({
                        label: item.title,
                        guildId: item.guildId,
                        value: item.id
                    });
                })
            setSurveys(opinionsArr);
        })
    },[]);

    const getData = (e,offset = 0,limit = 20) => {
        setIsLoading(true);
        const postedData = {
            p_offset: offset,
            p_limit: limit,
        }
        if(nationalCode)
            postedData.p_nationalcode = nationalCode;
        if(surveyId)
            postedData.p_opinion = surveyId?.value;
        if(surveyId){
            let codes = surveyId.map(survey => survey.value);
            codes = codes.join(',')
            postedData.p_opinion = codes;
        }
        getReports(postedData).then(({ data }) => {
            let finalResponse = [];
            if(data.status && data.result.v_result.length){
                finalResponse = data.result.v_result.map(row => {
                    let total = 0;
                    const thisState = JSON.parse(row.state);
                    const state = thisState.map(st => {
                        total += st.cnt;
                        return {
                            guild_name: st.guild_name,
                            cnt: st.cnt
                        };
                    })
                    state.push({
                        guild_name: 'مجموع',
                        cnt: total
                    });
                    return {
                        ...row,
                        state
                    }
                })  
            }else{
                setRows([])
            }
            if(e !== null)
                calcPages(data.result.v_count[0].cnt_total);
            setRows(finalResponse);
        }).finally(() => {
            setFetchedData(true);
            setIsLoading(false);
        })
    }

    const calcPages = res => {
        let calcPages = res / 20;
        setCount(res)
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        getData(null,page);
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        getData(null,currentPage - 1);
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        getData(null,currentPage + 1);
    }

    return (
        <div className="card">
            <div className="card-header px-4">
                <div className="card-title">گزارشات تجمیعی قرعه کشی</div>
            </div>
            <div className="card-body p-4">
                {!!isLoading && <div className="loading-box">
                    <img src="/assets/images/loading.gif" alt="" />
                </div>}
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی</label>
                            <input type="tel" className="form-control ltr-input" maxLength={10} value={nationalCode} onChange={e => setNationalCode(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>نظرسنجی</label>
                            <ReactSelect
                                isMulti
                                options={surveys}
                                value={surveyId}
                                onChange={value => setSurveyId(value)}
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    <div className="col-md-2" style={{marginTop: 30}}>
                        <button className="btn btn-primary pb-2" onClick={getData}>جستجو</button>
                    </div>
                </div>
                {fetchedData && rows.length ? <hr className="mt-1" /> : ''}
                {fetchedData && rows.length ? <><table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>نام و نام خانوادگی</th>
                            <th>کد ملی</th>
                            <th>شماره همراه</th>
                            <th>شرکت</th>
                            <th>گزارشات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row,index) => <tr key={index}>
                            <td>{row.full_name}</td>
                            <td>{row.nationalcode}</td>
                            <td>{row.consumer_mobile}</td>
                            <td>{row.companyname}</td>
                            <td>
                                <ul>
                                    {row.state.map((state,subIndex) => <li key={`li-${subIndex}`}><b>{state.guild_name} :</b> {state.cnt}</li>)}
                                </ul>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {count || 0}</p>
                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                </> : ''}
                {fetchedData && !rows.length ? <div className="alert alert-info mb-0"><p className="mb-0">داده ای یافت نشد !</p></div> : ''}
            </div>
        </div>
    )
}

export default Aggregate;